import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ChartLine, ShoppingBag, ShoppingCart, Bank, List } from "@phosphor-icons/react";

/**
 * Fixed bottom navigation bar — mobile only (hidden on lg+).
 * 5 slots: Dashboard, Penjualan, Pembelian, Kas & Bank, Menu (opens full sidebar).
 * Items with feature flag disabled are hidden gracefully.
 */
export default function MobileBottomNav({ features, onOpenMenu }) {
  const navigate = useNavigate();
  const items = [
    { to: "/app/dashboard", label: "Dasbor", icon: ChartLine, feature: null },
    { to: "/app/sales", label: "Jual", icon: ShoppingBag, feature: "sales" },
    { to: "/app/purchases", label: "Beli", icon: ShoppingCart, feature: "purchases" },
    { to: "/app/cashbank", label: "Kas", icon: Bank, feature: "cash_bank" },
  ].filter((it) => !it.feature || features?.[it.feature]);

  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-slate-200 shadow-[0_-2px_8px_rgba(15,23,42,0.06)] pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-stretch justify-around">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`mnav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 py-2 gap-0.5 text-[10px] font-medium transition-colors ${
                isActive ? "text-slate-900" : "text-slate-500"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={20} weight={isActive ? "fill" : "regular"} />
                <span>{label}</span>
                {isActive && <span className="h-0.5 w-6 bg-amber-600 rounded-full -mb-1" />}
              </>
            )}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={onOpenMenu}
          data-testid="mnav-menu"
          className="flex flex-col items-center justify-center flex-1 py-2 gap-0.5 text-[10px] font-medium text-slate-500"
        >
          <List size={20} />
          <span>Menu</span>
        </button>
      </div>
    </nav>
  );
}
